export enum ReminderStatus {
  Sent = 'sent',
  Failed = 'failed',
}
